<header class="container-fluid fixed-top main-header">
    <div class="row">
        <div class="col-12 px-0">
            <app-header [displaySessionIcons]="false"></app-header>
        </div>
    </div>
</header>
<section class="container-fluid main-content">
    <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-8 my-5">
             <!-- White card wrapper -->
             <div class="white-card">
                <div class="row">
                     <div class="col-12 px-0">
                        <router-outlet></router-outlet>
                    </div>
                 </div>
             </div>
        </div>
    </div>
</section>
<footer class="container-fluid main-footer">
    <div class="row">
        <div class="col-12 px-0">
            <app-footer></app-footer>
        </div>
    </div>
</footer>
